"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializeMap;
function initializeMap(latitude, longitude, mapReference) {
  var mapId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DEMO_MAP_ID';
  return new google.maps.Map(mapReference.current, {
    center: {
      lat: latitude,
      lng: longitude
    },
    mapId,
    zoom: 11,
    mapTypeControl: true,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM
    },
    streetViewControl: true,
    zoomControl: true,
    fullscreenControl: true,
    styles: [{
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.business',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.hotel',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }]
  });
}